import React from 'react';
import BaseContainer from '../../../block-container';
import { ReaderBlock } from '../../Reader/core';
export default function ContainerReader({ style, props }) {
    var _e;
    const childrenIds = (_e = props === null || props === void 0 ? void 0 : props.childrenIds) !== null && _e !== void 0 ? _e : [];
    return (React.createElement(BaseContainer.Component, { style: style }, childrenIds.map((childId) => (React.createElement(ReaderBlock, { key: childId, id: childId })))));
}
//# sourceMappingURL=ContainerReader.js.map